import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../../hooks/use-is-mobile';
import { breakPaymentKeywords } from '../../../utils/payment-autofill';

interface ExpiryDateFieldProps {
  value: string;
  onChange: (value: string) => void;
  showError?: boolean;
}

export function ExpiryDateField({ value, onChange, showError = false }: ExpiryDateFieldProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const hasError = showError && value === '';

  return (
    <TextField
      label={breakPaymentKeywords(t('goodsReceiving.expiryDate'))}
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      required
      name="use-by-date"
      slotProps={{
        inputLabel: { shrink: true },
        input: {
          // Evita che Chrome classifichi il form come modulo di pagamento
          // (data scadenza carta) e proponga l'autofill dei metodi di pagamento.
          autoComplete: 'off',
          name: 'use-by-date',
          style: { fontSize: isMobile ? '16px' : undefined },
        },
      }}
      error={hasError}
      helperText={hasError ? t('goodsReceiving.expiryDateRequired') : undefined}
    />
  );
}
